import { useDateHook } from '../../../hook/useDateHook';
import { infoStore } from '../../../store/infoStore';
import { End } from './End';
import { ProgressTicket } from './ProgressTicket';

export const ProgressInfo = ({
  goMainEventTab,
  goOnlineTab,
  goOfflineTab,
}: {
  goMainEventTab: () => void;
  goOnlineTab: () => void;
  goOfflineTab: () => void;
}) => {
  const { isSatelliteEnd } = useDateHook();
  const { info } = infoStore();

  if (info.ticketCnt === 0 || isSatelliteEnd()) {
    return <End goOfflineTab={goOfflineTab} />;
  }

  return <ProgressTicket goMainEventTab={goMainEventTab} goOnlineTab={goOnlineTab} />;
};
